import { render, staticRenderFns } from "./VarForm.affise_vars.vue?vue&type=template&id=15c4ad51&scoped=true&lang=html&"
import script from "./VarForm.affise_vars.vue?vue&type=script&lang=js&"
export * from "./VarForm.affise_vars.vue?vue&type=script&lang=js&"
import style0 from "./VarForm.affise_vars.vue?vue&type=style&index=0&id=15c4ad51&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c4ad51",
  null
  
)

export default component.exports